// extracted by mini-css-extract-plugin
export default {"root":"FramedWizard_root__yfNzM","wizard":"FramedWizard_wizard__oUkji","breadcrumbs":"FramedWizard_breadcrumbs__VcodD","close":"FramedWizard_close__o5hDf"};